module.exports = __webpack_public_path__ + "img/map-pin@2x.ad85d936.png";